// Common country list (ISO-3166 alpha-2). Trimmed to ~120 entries prioritising
// pharmaceutical markets, MEA + Asia + EU + Americas. `code` is stored,
// `name` is displayed. Extend as needed.

export const COUNTRIES = [
  ["AE", "United Arab Emirates"],
  ["SA", "Saudi Arabia"],
  ["QA", "Qatar"],
  ["BH", "Bahrain"],
  ["KW", "Kuwait"],
  ["OM", "Oman"],
  ["JO", "Jordan"],
  ["LB", "Lebanon"],
  ["SY", "Syria"],
  ["IQ", "Iraq"],
  ["IR", "Iran"],
  ["IL", "Israel"],
  ["PS", "Palestinian Territories"],
  ["TR", "Türkiye"],
  ["EG", "Egypt"],
  ["MA", "Morocco"],
  ["TN", "Tunisia"],
  ["DZ", "Algeria"],
  ["LY", "Libya"],
  ["SD", "Sudan"],
  ["SS", "South Sudan"],
  ["ET", "Ethiopia"],
  ["ER", "Eritrea"],
  ["DJ", "Djibouti"],
  ["SO", "Somalia"],
  ["KE", "Kenya"],
  ["UG", "Uganda"],
  ["TZ", "Tanzania"],
  ["RW", "Rwanda"],
  ["BI", "Burundi"],
  ["MG", "Madagascar"],
  ["MU", "Mauritius"],
  ["ZA", "South Africa"],
  ["NA", "Namibia"],
  ["BW", "Botswana"],
  ["ZW", "Zimbabwe"],
  ["ZM", "Zambia"],
  ["MW", "Malawi"],
  ["MZ", "Mozambique"],
  ["AO", "Angola"],
  ["CD", "DR Congo"],
  ["CG", "Congo"],
  ["GA", "Gabon"],
  ["CM", "Cameroon"],
  ["NG", "Nigeria"],
  ["GH", "Ghana"],
  ["CI", "Côte d’Ivoire"],
  ["SN", "Senegal"],
  ["ML", "Mali"],
  ["BF", "Burkina Faso"],
  ["NE", "Niger"],
  ["TD", "Chad"],
  ["MR", "Mauritania"],
  ["GM", "Gambia"],
  ["GN", "Guinea"],
  ["SL", "Sierra Leone"],
  ["LR", "Liberia"],
  ["TG", "Togo"],
  ["BJ", "Benin"],
  ["CF", "Central African Republic"],
  ["IN", "India"],
  ["PK", "Pakistan"],
  ["BD", "Bangladesh"],
  ["LK", "Sri Lanka"],
  ["NP", "Nepal"],
  ["BT", "Bhutan"],
  ["MV", "Maldives"],
  ["AF", "Afghanistan"],
  ["MM", "Myanmar"],
  ["TH", "Thailand"],
  ["VN", "Vietnam"],
  ["LA", "Laos"],
  ["KH", "Cambodia"],
  ["MY", "Malaysia"],
  ["SG", "Singapore"],
  ["ID", "Indonesia"],
  ["PH", "Philippines"],
  ["CN", "China"],
  ["HK", "Hong Kong"],
  ["TW", "Taiwan"],
  ["JP", "Japan"],
  ["KR", "South Korea"],
  ["KP", "North Korea"],
  ["MN", "Mongolia"],
  ["KZ", "Kazakhstan"],
  ["UZ", "Uzbekistan"],
  ["TM", "Turkmenistan"],
  ["TJ", "Tajikistan"],
  ["KG", "Kyrgyzstan"],
  ["AZ", "Azerbaijan"],
  ["AM", "Armenia"],
  ["GE", "Georgia"],
  ["RU", "Russia"],
  ["UA", "Ukraine"],
  ["BY", "Belarus"],
  ["MD", "Moldova"],
  ["RO", "Romania"],
  ["BG", "Bulgaria"],
  ["GR", "Greece"],
  ["CY", "Cyprus"],
  ["MT", "Malta"],
  ["IT", "Italy"],
  ["ES", "Spain"],
  ["PT", "Portugal"],
  ["FR", "France"],
  ["BE", "Belgium"],
  ["NL", "Netherlands"],
  ["LU", "Luxembourg"],
  ["DE", "Germany"],
  ["AT", "Austria"],
  ["CH", "Switzerland"],
  ["LI", "Liechtenstein"],
  ["PL", "Poland"],
  ["CZ", "Czechia"],
  ["SK", "Slovakia"],
  ["HU", "Hungary"],
  ["SI", "Slovenia"],
  ["HR", "Croatia"],
  ["RS", "Serbia"],
  ["ME", "Montenegro"],
  ["MK", "North Macedonia"],
  ["AL", "Albania"],
  ["XK", "Kosovo"],
  ["BA", "Bosnia and Herzegovina"],
  ["DK", "Denmark"],
  ["SE", "Sweden"],
  ["NO", "Norway"],
  ["FI", "Finland"],
  ["IS", "Iceland"],
  ["EE", "Estonia"],
  ["LV", "Latvia"],
  ["LT", "Lithuania"],
  ["IE", "Ireland"],
  ["GB", "United Kingdom"],
  ["US", "United States"],
  ["CA", "Canada"],
  ["MX", "Mexico"],
  ["BR", "Brazil"],
  ["AR", "Argentina"],
  ["CL", "Chile"],
  ["PE", "Peru"],
  ["CO", "Colombia"],
  ["VE", "Venezuela"],
  ["EC", "Ecuador"],
  ["BO", "Bolivia"],
  ["PY", "Paraguay"],
  ["UY", "Uruguay"],
  ["CR", "Costa Rica"],
  ["PA", "Panama"],
  ["GT", "Guatemala"],
  ["HN", "Honduras"],
  ["SV", "El Salvador"],
  ["NI", "Nicaragua"],
  ["DO", "Dominican Republic"],
  ["CU", "Cuba"],
  ["JM", "Jamaica"],
  ["TT", "Trinidad and Tobago"],
  ["AU", "Australia"],
  ["NZ", "New Zealand"],
  ["PG", "Papua New Guinea"],
  ["FJ", "Fiji"],
];
